const roundNumber = (value: number, decimals: number): number =>
  +value.toFixed(decimals);

export const getLargestRemainderPercentages = (
  values = [],
  decimals = 0,
): { key: number; value: number }[] => {
  const absoluteTotal = values.reduce((total, value) => total + value, 0);
  const roundedValues = values.map((value, key) => {
    const percentage = (value / absoluteTotal) * 100;

    return {
      key,
      value: roundNumber(percentage, decimals),
    };
  });

  const diff =
    100 - roundedValues.reduce((total, item) => total + item.value, 0);
  const sortedValues = roundedValues.sort(
    ({ value }) => Math.floor(value) - value,
  );

  return sortedValues.map(({ value, ...item }, index) => {
    const roundedValue = roundNumber(value, decimals);

    return {
      ...item,
      value: index < diff ? roundedValue + 1 : roundedValue,
    };
  });
};
